import "./blog.css";
import { NavLink } from "react-router-dom";
import Volunteer from "../volunteer/Volunteer";
import React, { useState, useEffect } from "react";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { server } from "../../common";
const Blogs = () => {
  const [data, setData] = useState([]);

  console.log(data, "dfa8aaaghahg");

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    server
      .get("/blogs/getallblogs", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  return (
    <>
      <section className="abt-01 mb-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="heading-wrapper">
                <h3>Blogs</h3>
                <ol>
                  <li>
                    Home<i className="fa fa-angle-double-right"></i>
                  </li>
                  <li>Blogs</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-04 mb-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="heading">
                <h2>Latest Blogs</h2>
              </div>
            </div>

            <div className="row d-flex">
              {data.map((item) => {
                return (
                  <>
                    <NavLink
                      to={item.link}
                      className="col-md-4 text-decoration-none"
                    >
                      <article>
                        <div className="card">
                          <div className="">
                            <img
                              src={item.image}
                              className="card-img-top"
                              height={230}
                            />
                          </div>
                          <div className="card-body"></div>
                          <div className="p-2">
                            <div className="">
                              <h4>{item.title}</h4>
                              <p style={{ textAlign: "justify" }}>
                                {item.description}
                              </p>
                            </div>
                            <div className="blog-admin text-center">
                              <div className="btn btn-success btn-sm">
                                <NavLink
                                  to={item.link}
                                  className="text-white text-decoration-none"
                                >
                                  Read More
                                </NavLink>
                              </div>
                            </div>
                          </div>
                        </div>
                      </article>
                    </NavLink>
                  </>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <Volunteer />
    </>
  );
};

export default Blogs;
